var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "bg-white" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            attrs: {
              data: _vm.list,
              "element-loading-text": "Loading",
              stripe: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "合伙人", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          ID：" +
                          _vm._s(scope.row.agent_id) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "小程序" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v("名称：" + _vm._s(scope.row.app_name || "--")),
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("APPID：" + _vm._s(scope.row.appId))]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "信用服务ID", width: "140" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.service_id) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "更新时间", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(_vm.parseTime(scope.row.updated))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm.siteInfo.zfb_third_api_switch
              ? _c("el-table-column", {
                  attrs: {
                    label: "最新模板",
                    "render-header": _vm.renderHeader,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.templateInfo.template_id
                              ? [
                                  _c("div", [
                                    _vm._v(
                                      "ID：" +
                                        _vm._s(
                                          scope.row.templateInfo.template_id
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "版本：" +
                                        _vm._s(_vm.new_template_version)
                                    ),
                                  ]),
                                ]
                              : [_vm._v("--")],
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    460848995
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.siteInfo.zfb_third_api_switch
              ? _c("el-table-column", {
                  attrs: { label: "当前模板版本" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.templateInfo.template_version
                              ? [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.templateInfo.template_version
                                      )
                                    ),
                                  ]),
                                ]
                              : [_vm._v("--")],
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3178862045
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.siteInfo.zfb_third_api_switch
              ? _c("el-table-column", {
                  attrs: { label: "小程序版本" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.templateInfo.app_version
                              ? [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.templateInfo.app_version)
                                    ),
                                  ]),
                                ]
                              : [_vm._v("--")],
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4038494813
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.siteInfo.zfb_third_api_switch
              ? _c("el-table-column", {
                  attrs: { label: "状态", width: "180" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.templateInfo.template_version
                              ? [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.small_version_status[
                                          scope.row.templateInfo.status
                                        ]
                                      )
                                    ),
                                  ]),
                                ]
                              : [_vm._v("--")],
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1959052683
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.siteInfo.zfb_third_api_switch
              ? _c("el-table-column", {
                  attrs: { label: "代码", width: "100" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.templateInfo.status == "RELEASE" ||
                            !scope.row.templateInfo.status
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.uploadCode(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("上传代码")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.templateInfo
                              ? [
                                  scope.row.templateInfo.status == "BUILD"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.miniVersion(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("版本状态")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status == "INIT"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.auditMiniCode(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("提交审核")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status == "AUDITING"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.refreshAudit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("审核状态")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status == "AUDITING"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.backAudit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("撤销审核")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status ==
                                  "AUDIT_REJECT"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.backCode(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("退回开发")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status ==
                                    "WAIT_RELEASE" ||
                                  scope.row.templateInfo.status == "GRAY"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.releaseCode(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("发布代码")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.templateInfo.status == "INIT" ||
                                  scope.row.templateInfo.status == "AUDITING"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "e-btn mt-10",
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewEx(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("体验版")]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkRoles(["terminal"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "e-btn mt-10",
                                    attrs: { type: "danger", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delVersion(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除版本")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3562735970
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          staticClass: "mr-10",
                          attrs: { to: "/ali/edit/" + scope.row.appId },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-edit",
                              circle: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.list.length == 0 && _vm.agentInfo.agent_level == 1
          ? _c(
              "div",
              { staticClass: "p-30 flex justify-center" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/ali/create" } },
                  [
                    _c("el-button", { attrs: { type: "primary", round: "" } }, [
                      _vm._v("绑定小程序"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listQuery.total > 0,
                  expression: "listQuery.total > 0",
                },
              ],
              attrs: {
                page: _vm.listQuery.page,
                limit: _vm.listQuery.limit,
                "page-count": _vm.listQuery.total,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "page", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "limit", $event)
                },
                pagination: _vm.getList,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }